import { selectCountries } from 'legacy/lut/selectors/app'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Market, Region } from 'clickNgo/configs/geo'
import { Nullable } from 'clickNgo/models/utils'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IUseCountrySourceParams {
  market?: Nullable<Market>
  region?: Nullable<Region>
  isStatic?: boolean
}

export const useCountrySource = ({
  isStatic,
  market = null,
  region = null,
}: IUseCountrySourceParams = {}) => {
  const countries = useSelector(selectCountries, (prev, next) => prev.length === next.length)

  const filteredCountries = useMemo(
    () =>
      countries.filter(
        (country) =>
          (!market || country.market === market) && (!region || country.region === region)
      ),
    [countries, market, region]
  )

  const crudParams = useMemo(
    () => ({
      fetcher: new Static(filteredCountries),
      keyField: 'name',
    }),
    [filteredCountries]
  )
  const crudStaticParams = useMemo(
    () => ({
      ...crudParams,
      defaultPaging: {
        page: 0,
        pageSize: filteredCountries.length,
      },
      defaultSort: {
        field: 'name',
        dir: 'asc' as const,
      },
    }),
    [filteredCountries.length, crudParams]
  )

  return useMemo(
    () => (isStatic ? new Crud(crudStaticParams) : new Crud(crudParams)),
    [crudParams, crudStaticParams, isStatic]
  )
}
